import type { Theme } from '@mui/material';
import type { CSSObject } from '@mui/material/styles';
import { designTokens } from './tokens';

export type MotionRole = keyof typeof designTokens.motion;

export type FocusRingOptions = {
  /** 메뉴·탐색처럼 바깥 강조가 잘릴 수 있는 영역은 안쪽에 표시합니다. */
  inset?: boolean;
  color?: string;
};

/** hover·선택 배경과 독립적인 키보드 초점 표시입니다. 선택자는 소비자가 소유합니다. */
export function createFocusRingStyles({ inset = false, color = designTokens.overlay.focusStrong }: FocusRingOptions = {}): CSSObject {
  return {
    outline: `2px solid ${color}`,
    outlineOffset: inset ? -2 : 2,
    '@media (forced-colors: active)': { outlineColor: 'Highlight' },
  };
}

/** 동작 시간과 가속도를 역할별로 재사용합니다. reduced-motion은 공용 theme이 적용합니다. */
export function createMotionTransition(properties: string | readonly string[], role: MotionRole = 'feedback') {
  const { duration, easing } = designTokens.motion[role];
  return (typeof properties === 'string' ? [properties] : properties).map((property) => `${property} ${duration}ms ${easing}`).join(', ');
}

/** MUI의 기본 순서를 유지합니다. 표 내부 고정 셀 등 로컬 겹침 순서는 각 표가 소유합니다. */
export const designLayers = {
  workspaceHeader: (theme: Theme) => theme.zIndex.drawer + 1,
  stickySection: (theme: Theme) => theme.zIndex.appBar - 1,
  detail: (theme: Theme) => theme.zIndex.modal,
  skipLink: (theme: Theme) => theme.zIndex.tooltip + 1,
};
